// extracted by mini-css-extract-plugin
export var statItem = "_jg-1";
export var statsRow = "_jg-0";